import { render, staticRenderFns } from "./ownerExitRoomList.vue?vue&type=template&id=1174b538&scoped=true"
import script from "./ownerExitRoomList.vue?vue&type=script&lang=js"
export * from "./ownerExitRoomList.vue?vue&type=script&lang=js"
import style0 from "./ownerExitRoomList.vue?vue&type=style&index=0&id=1174b538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1174b538",
  null
  
)

export default component.exports